import template from './whatIsSolidaryEuro.html';
import './whatIsSolidaryEuro.scss';

let whatIsSolidaryEuroComponent = {
  restrict: 'E',
  bindings: {
    setShowMoreInfo:'&',
  },
  template
};

export default whatIsSolidaryEuroComponent;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/components/whatIsSolidaryEuro/whatIsSolidaryEuro.component.js